import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalQuestaoAcaoEnum } from 'src/app/shared/enums/modal-questao-acao.enum';
import * as bootstrap from 'bootstrap';

@Component({
  selector: 'app-modal-questao-simples',
  templateUrl: './modal-questao-simples.component.html',
  styleUrl: './modal-questao-simples.component.scss'
})
export class ModalQuestaoSimplesComponent {
  readonly modalQuestaoAction = ModalQuestaoAcaoEnum;

  private static contadorInstancias = 0;

  // Id próprio de cada instância: uma mesma tela pode declarar mais de uma
  // modal (ex.: Excluir e Voltar Status na lista de tarefas do pedido).
  readonly tituloId = `modal-questao-simples-titulo-${++ModalQuestaoSimplesComponent.contadorInstancias}`;

  @Input() titulo: string = 'Confirmar ação';
  @Input() descricao: string = 'Tem certeza que deseja continuar?';
  @Input() showCancelar: boolean = false;
  @Input() descricaoButtonSim: string = "Confirmar";
  @Input() descricaoButtonFechar: string = "Fechar";
  @Input() descricaoButtonCancelar: string = "Cancelar";

  @Output() acaoSelecionada = new EventEmitter<ModalQuestaoAcaoEnum>();

  @ViewChild('modalElement') private modalElement?: ElementRef<HTMLElement>;

  constructor() {}

  onSim() {
    this.acaoSelecionada.emit(ModalQuestaoAcaoEnum.SIM);
    this.fecharModal();
  }

  onNao() {
    this.acaoSelecionada.emit(ModalQuestaoAcaoEnum.NAO);
    this.fecharModal();
  }

  onCancelar() {
    this.acaoSelecionada.emit(ModalQuestaoAcaoEnum.CANCELAR);
    this.fecharModal();
  }

  private fecharModal() {
    this.obterModal()?.hide();
  }

  abrirModal() {
    this.obterModal()?.show();
  }

  // Resolve a modal pelo elemento desta instância. Buscar por id no document
  // devolveria sempre a primeira do DOM quando há várias na mesma tela.
  private obterModal(): bootstrap.Modal | null {
    if (!this.modalElement) {
      return null;
    }

    return bootstrap.Modal.getOrCreateInstance(this.modalElement.nativeElement);
  }
}
